// Towns & areas within roughly 50 miles of Glasgow, grouped by council area.
export const AREA_GROUPS = [
  ["Glasgow City", ["Glasgow City Centre", "Glasgow North", "Glasgow South", "Glasgow East", "Glasgow West"]],
  ["East Dunbartonshire", ["Bearsden", "Milngavie", "Bishopbriggs", "Kirkintilloch", "Lenzie"]],
  ["West Dunbartonshire", ["Clydebank", "Dumbarton", "Alexandria", "Balloch"]],
  ["Renfrewshire", ["Paisley", "Renfrew", "Johnstone", "Erskine", "Linwood", "Bridge of Weir"]],
  ["East Renfrewshire", ["Newton Mearns", "Giffnock", "Clarkston", "Barrhead", "Busby"]],
  ["Inverclyde", ["Greenock", "Gourock", "Port Glasgow"]],
  ["North Lanarkshire", ["Airdrie", "Coatbridge", "Cumbernauld", "Kilsyth", "Motherwell", "Wishaw", "Bellshill", "Shotts"]],
  ["South Lanarkshire", ["Hamilton", "East Kilbride", "Rutherglen", "Cambuslang", "Blantyre", "Uddingston", "Larkhall", "Strathaven", "Carluke", "Lanark", "Biggar"]],
  ["East Ayrshire", ["Kilmarnock", "Stewarton", "Cumnock", "Galston", "Darvel"]],
  ["North Ayrshire", ["Irvine", "Kilwinning", "Saltcoats", "Ardrossan", "Stevenston", "Largs", "Beith", "Dalry"]],
  ["South Ayrshire", ["Ayr", "Prestwick", "Troon", "Maybole", "Girvan"]],
  ["Stirling & Clackmannanshire", ["Stirling", "Bridge of Allan", "Dunblane", "Callander", "Alloa", "Tillicoultry"]],
  ["Falkirk", ["Falkirk", "Grangemouth", "Bo'ness", "Larbert", "Denny"]],
  ["West Lothian", ["Livingston", "Bathgate", "Linlithgow", "Broxburn", "Whitburn", "Armadale"]],
  ["Edinburgh & Argyll", ["Edinburgh", "Helensburgh", "Dunoon"]],
];

export const ALL_AREAS = AREA_GROUPS.flatMap(([, towns]) => towns);
